/**
 * Dynamically inject a script tag.
 *
 * @param {string} src URL of script to load.
 * @returns void
 */
export const loadScript = (
  src,
  scriptIsText = false
) => {
  if (! src) {
    return;
  }

  const script = document.createElement('script');
  if (scriptIsText) {
    script.text = src;
  } else {
    script.src = src;
  }

  script.async = true;

  document.body.appendChild(script);
};

/**
 * Checks for script tag from html string.  If script tag found, it is extracted, returning tag and html.
 *
 * @param {string} html HTML string from rendered JSON output.
 * @returns {Object}
 * @returns {string} Script Tag SRC
 * @returns {string} HTML
 */
export const getScriptSrc = (html) => {
  let scriptSrc = '';
  let scriptIsText = false;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const [script] = doc.getElementsByTagName('script');

  if (script) {
    scriptSrc = 0 < script.src.length ? script.src : script.textContent;
    script.parentNode.removeChild(script);
    scriptIsText = 0 === script.src.length;
  }

  const updatedHtml = doc.documentElement.innerHTML;

  return {
    scriptSrc,
    updatedHtml,
    scriptIsText,
  };
};
